import { render } from "./FilterText.vue?vue&type=template&id=1e866b9d"
import script from "./FilterText.vue?vue&type=script&lang=js"
export * from "./FilterText.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/tribuk-ui/tribuk-ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__